import { createContext, useContext } from 'react';
import { en } from './en';
import { pt, type MessageKey } from './pt';
import type { LocaleCode } from '@/shared/storage';

const dictionaries = { pt, en } as const;

export function translate(
  locale: LocaleCode,
  key: MessageKey,
  vars?: Record<string, string>,
): string {
  const template = dictionaries[locale][key] ?? pt[key];
  if (!vars) return template;
  return Object.entries(vars).reduce(
    (text, [name, value]) => text.split(`{${name}}`).join(value),
    template,
  );
}

export interface I18nContextValue {
  locale: LocaleCode;
  setLocale: (locale: LocaleCode) => void;
  t: (key: MessageKey, vars?: Record<string, string>) => string;
}

export const I18nContext = createContext<I18nContextValue | null>(null);

export function useI18n(): I18nContextValue {
  const ctx = useContext(I18nContext);
  if (!ctx) {
    throw new Error('useI18n must be used within I18nProvider');
  }
  return ctx;
}
